import './spinner.css';

const Spinner = () => {
    return (
        <div className="spinner">
            <div className="cube1"></div>
            <div className="cube2"></div>
        </div>
    );
};

export default Spinner;
